import { render } from "./GameVote.vue?vue&type=template&id=6e0c7773&scoped=true"
import script from "./GameVote.vue?vue&type=script&lang=js"
export * from "./GameVote.vue?vue&type=script&lang=js"

import "./GameVote.vue?vue&type=style&index=0&id=6e0c7773&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0c7773"]])

export default __exports__